import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

import {
    OnlineChatUpdateDialogStatusActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import {
    getActionDescriptionModelType,
    useActionBlockFormProps
} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";
import {computed} from "vue";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";
import {OnlineChatUpdateDialogStatusParamInterface} from "~/cabinet/vue/client/events/action/types/Interface";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


const __default__ = {
    name: "OnlineChatUpdateDialogStatusForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useActionBlockFormProps<OnlineChatUpdateDialogStatusActionDescription>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props;


let statusList = computed(() => {
    return props.actionDescription.frontendParams.statusList;
});

let operators = computed(() => {
    return props.actionDescription.frontendParams.operators;
});

let groups = computed(() => {
    return props.actionDescription.frontendParams.groups;
});

let _modelValue = _useModel<getActionDescriptionModelType<OnlineChatUpdateDialogStatusActionDescription>>(__props, "modelValue");
let model = useObjectModel(_modelValue, () => {
    let result: OnlineChatUpdateDialogStatusParamInterface = {
        statusId: statusList.value.find(item => item.isClosed)?.id,
        isChangeAssigned: false,
        markAsRead: false,
        removeFromBuddyList: false,
        newAssignedOperatorGroups: [],
        newAssignedOperatorLogins: []
    }
    return result;
});


let selectedStatus = computed(() => statusList.value.find(item => item.id == model.value.statusId));

let selectValue = computed(() => {
    return [...model.value.newAssignedOperatorGroups, ...model.value.newAssignedOperatorLogins];
});

function onSelectInput(value: string[]) {
    let groupIds: string[] = [];
    let operatorLogins: string[] = [];
    for (let item of value) {
        if (groups.value.find(group => group.id === item)) {
            groupIds.push(item);
        } else if (operators.value.find(operator => operator.login === item)) {
            operatorLogins.push(item);
        }
    }
    model.value.newAssignedOperatorLogins = operatorLogins;
    model.value.newAssignedOperatorGroups = groupIds;
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "200px",
    model: _unref(model)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "Новый статус диалога",
        rules: _unref(requiredRule),
        prop: "statusId"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _unref(model).statusId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).statusId) = $event)),
            class: "w-100",
            placeholder: "Выберите статус"
          }, _createSlots({
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusList), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.descr
                }, {
                  default: _withCtx(() => [
                    (item.icon)
                      ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                          key: 0,
                          icon: item.icon,
                          "icon-style": item.iconStyle,
                          style: _normalizeStyle({color: item.color}),
                          class: "mr-2"
                        }, null, 8, ["icon", "icon-style", "style"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(item.descr), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 128))
            ]),
            _: 2
          }, [
            (_unref(selectedStatus))
              ? {
                  name: "label",
                  fn: _withCtx(() => [
                    (_unref(selectedStatus).icon)
                      ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                          key: 0,
                          icon: _unref(selectedStatus).icon,
                          "icon-style": _unref(selectedStatus).iconStyle,
                          style: _normalizeStyle({color: _unref(selectedStatus).color}),
                          class: "mr-1"
                        }, null, 8, ["icon", "icon-style", "style"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_unref(selectedStatus).descr), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue"])
        ]),
        _: 1
      }, 8, ["rules"]),
      (!_unref(selectedStatus)?.isClosed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _unref(model).isChangeAssigned,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).isChangeAssigned) = $event)),
                  class: "mr-2"
                }, null, 8, ["modelValue"]),
                _cache[4] || (_cache[4] = _createTextVNode(" Изменять ответственных за диалог ", -1))
              ]),
              _: 1
            }),
            (_unref(model).isChangeAssigned)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "Новые ответственные"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      "model-value": [..._unref(selectValue)],
                      placeholder: "Без ответственных",
                      "onUpdate:modelValue": onSelectInput,
                      multiple: "",
                      clearable: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_unref(groups).length)
                          ? (_openBlock(), _createBlock(_component_el_option_group, {
                              key: 0,
                              label: "Отделы операторов"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (group) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: group.descr,
                                    value: group.id
                                  }, null, 8, ["label", "value"]))
                                }), 256))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(operators).length)
                          ? (_openBlock(), _createBlock(_component_el_option_group, {
                              key: 1,
                              label: "Операторы"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    value: operator.login,
                                    label: operator.descr
                                  }, null, 8, ["value", "label"]))
                                }), 256))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_switch, {
            modelValue: _unref(model).markAsRead,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).markAsRead) = $event)),
            class: "mr-2"
          }, null, 8, ["modelValue"]),
          _cache[5] || (_cache[5] = _createTextVNode(" Помечать сообщения прочитанными ", -1))
        ]),
        _: 1
      }),
      (_unref(model).markAsRead && _unref(selectedStatus)?.isClosed === true)
        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _unref(model).removeFromBuddyList,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).removeFromBuddyList) = $event)),
                class: "mr-2"
              }, null, 8, ["modelValue"]),
              _cache[6] || (_cache[6] = _createTextVNode(" Удалять из списка контактов ", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})